<template>
    <div>
        <div class="row pt-2 mb-1">
            <div class="col-12">
                <div class="card ob1-push ob1-push-zigzag ob1-push-zigzag-odd ob1-push-shadow-right">
                    <div class="card-item">
                        <div class="card-header">
                            <img :src="zoneReassurance.image.src" class="card-img-top" :alt="zoneReassurance.image.alt">
                        </div>
                    </div>
                    <div class="card-item">
                        <div class="card-body">
                            <h3 class="h3 card-title" data-clamp="2">
                                {{ zoneReassurance.title }}
                                <span class="orange-on">on</span>
                            </h3>
                            <p class="card-text">
                                {{ zoneReassurance.text }}
                            </p>
                            <p class="py-0 card-btn">
                                <a
                                    :href="zoneReassurance.urlButton"
                                    class="btn btn-secondary"
                                    :data-oevent-category="zoneReassurance.tms.tagZone"
                                    :data-oevent-action="zoneReassurance.tms.tagName"
                                    :data-oevent-label="zoneReassurance.urlButton"
                                >{{ zoneReassurance.labelButton }}
                                    <span class="orange-on">on</span>
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        zoneReassurance: {
            type: Object,
            required: true
        },
    },
}
</script>

<style scoped lang="scss">
//Iso prod
.orange-on {
    font-size: 1.35em;
    line-height: .6em;
}
</style>
